export default __webpack_public_path__ + "images/0eaa38f8628fd1190d2ce83112515e58-charlotte_desktop.webp";